import { PROCEED_TO_CHECKOUT } from "./actionTypes";

export const proceedToCheckout = (cartItems, totalAmount) => ({
  type: PROCEED_TO_CHECKOUT,
  payload: {
    items: cartItems,
    total: totalAmount,
  },
});
